import React from 'react';
import Zearch from '../components/Zearch';

const ZearchPage = () => {
  return (
    <div className="page-container" style={{ maxWidth: '1200px', padding: 0 }}>
      <Zearch />
    </div>
  );
};

export default ZearchPage;
